//imports
import React, { useState, useRef } from "react";
import Barcode from "react-barcode";
import {
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Box,
  Paper,
  Toolbar,
  Snackbar,
  Alert,
  Slide,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import { externalpostApi } from "../../services/external/externalApis";
import { SETTINGS_API_23 } from "../../api/ApiModel";
import { useSelector } from "react-redux";

const BarcodeGenerator = ({ selectedMenuName, selectedMenucode, isEdit }) => {
  //hooks
  const [barcodeValue, setBarcodeValue] = useState("");
  const [autoGenerate, setAutoGenerate] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const theme = useTheme();
  const styles = useStyles(theme);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  const barcodeRef = useRef(null);
  //functions
  const handleCheckboxChange = (event) => {
    setAutoGenerate(event.target.checked);
    if (event.target.checked) {
      generateBarcode();
    }
  };

  const handleInputChange = (event) => {
    setBarcodeValue(event.target.value);
  };

  const generateBarcode = () => {
    const randomValue = Math.floor(Math.random() * 1000000000000).toString();
    setBarcodeValue(randomValue);
  };

  const getBarcodeImage = () => {
    if (barcodeRef.current) {
      const canvas = barcodeRef.current.querySelector("canvas");
      return canvas ? canvas.toDataURL("image/png") : "";
    }
    return "";
  };
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = () => {
    setOpenErrorSnackbar(false);
  };
  //postapi
  const handleConfirmClick = async () => {
    const encodedBarcodeValue = btoa(barcodeValue);
    const payload = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      MENUCODE: String(selectedMenucode),
      BARCODE: barcodeValue,
      BARCODEIMAGE: encodedBarcodeValue,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_23, payload);
      console.log("Success:", responseData);

      setSnackbarMessage(
        isEdit
          ? "Barcode Updated Successfully!"
          : "Barcode Created Successfully!"
      );
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage("Failed to generate barcode.");
      setOpenErrorSnackbar(true);
    }
  };

  return (
    <Box
      sx={{
        background: theme.palette.background.default,
        p: 2,
        borderRadius: "4px",
        boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
      }}
    >
      <Toolbar
        sx={{
          width: "100%",
          background: theme.palette.background.paper,
          marginTop: {
            xs: "170px",
            md: "5px",
          },
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
        }}
      >
        <Typography
          sx={{
            color: theme.palette.mode === "dark" ? "#FFFFFF" : "#181818",
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Generate Barcode
        </Typography>
      </Toolbar>
      <Paper elevation={5} style={{ padding: "2rem" }}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            color: theme.palette.mode === "dark" ? "#FFFFFF" : "#181818",
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Name: {selectedMenuName}
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          value={barcodeValue}
          onChange={handleInputChange}
          InputProps={{
            style: { textAlign: "center", fontSize: "1.5rem" },
          }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={autoGenerate}
              onChange={handleCheckboxChange}
              color="primary"
            />
          }
          label="Auto Generate Barcode"
        />
        <Box p={2} display="flex" justifyContent="center" ref={barcodeRef}>
          <Barcode value={barcodeValue} />
        </Box>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirmClick}
            sx={{
              textTransform: "capitalize",
              letterSpacing: "1px",
            }}
          >
            Confirm
          </Button>
        </Box>
      </Paper>

      {/* Success Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar
        open={openErrorSnackbar}
        autoHideDuration={6000}
        onClose={handleErrorSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleErrorSnackbarClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {snackbarMessage || "Please fill out all fields before submitting."}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default BarcodeGenerator;
